import { axiosInstance } from "../axiosConfig.ts";
import { IAddPaymentMethodResponse, ICard, IUpdateCardResponse } from "./types.ts";

export const cardsAPI = {
  getCards: async (signal?: AbortSignal): Promise<ICard[]> => {
    const response = await axiosInstance.get<ICard[]>(
      "/df/v1/recurrent/payment-types",
      { signal },
    );
    return response.data;
  },

  setMainProduct: async (productId: string): Promise<IUpdateCardResponse> => {
    const response = await axiosInstance.patch<IUpdateCardResponse>(
        `/df/v1/recurrent/cards/${productId}`,
        { mark: "MAIN" });
    return response.data;
  },

  deleteCard: async (productId: string): Promise<IUpdateCardResponse> => {
    const response = await axiosInstance.patch<IUpdateCardResponse>(
        `/df/v1/recurrent/cards/${productId}`,
        { mark: "DELETE" });
    return response.data;
  },

  addCard: async (signal?: AbortSignal): Promise<IAddPaymentMethodResponse> => {
    const response
        = await axiosInstance.post<IAddPaymentMethodResponse>(
          "/df/v1/recurrent/cards/verification",
          undefined,
          { signal },
        );

    return response.data;
  },

  addSbp: async (signal?: AbortSignal): Promise<IAddPaymentMethodResponse> => {
    const response
        = await axiosInstance.post<IAddPaymentMethodResponse>(
          "/df/v1/recurrent/sbp/verification",
          undefined,
          { signal },
        );

    return response.data;
  },

  addPaymentMethodPolling: async (
    {
      id,
      signal,
    }: {
      id: string;
      signal?: AbortSignal;
    }): Promise<IAddPaymentMethodResponse> => {
    const response
        = await axiosInstance.get<IAddPaymentMethodResponse>(
            `/df/v1/recurrent/applications/${id}/status`,
            { signal },
        );

    return response.data;
  },
};
